import * as React from "react";

import { matchPath, useLocation } from "react-router-dom";
import { useSite } from "../context/SitesContext";
import UserContext from "../context/UserContext";
import TopNavBar from "@src/straps/base/navigation/TopNavBar/TopNavBar";

export default function ConsoleNav() {
  const { currentUser } = React.useContext(UserContext);
  const { pathname } = useLocation();

  const siteId = matchPath<{
    siteId: string;
  }>(pathname, {
    path: "/site/:siteId",
    exact: false,
  })?.params?.siteId;
  const selectedSite = useSite(siteId);

  return <TopNavBar selectedSite={selectedSite} user={currentUser} />;
}
